import { render, staticRenderFns } from "./BasicProductCard.vue?vue&type=template&id=137d44da&scoped=true"
import script from "./BasicProductCard.vue?vue&type=script&lang=js"
export * from "./BasicProductCard.vue?vue&type=script&lang=js"
import style0 from "./BasicProductCard.vue?vue&type=style&index=0&id=137d44da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137d44da",
  null
  
)

export default component.exports